<div class="poptional">
  <div class="step-bar">
    @for (popt of poptionals; track popt; let i = $index) {
      <span class="dot" [class.active]="i == idx" [class.done]="i < idx"></span>
    }
  </div>
  <div class="step-label">{{idx + 1}} / {{poptionals.length}}</div>

  <h5>
    <span class="name">{{current.name}}</span>
    @if (current.priceNumber > 0 && current.subpoptionals.length == 0) {
      <div class="price">
        +{{current.priceNumber | currency:'BRL'}} cd.
      </div>
    }
    <br/>
    @if (current.subpoptionals.length > 0) {
      <span class="choice-title">{{current.choiceTitle(itemQty)}}</span>
    }
  </h5>

  @if (current.subpoptionals.length > 0) {
    <div>
      <div class="upper-controls">
        @if (curSelection.minReached) {
          <button class="btn btn-sm btn-primary" (click)="proceed()">
            {{lastStep() ? 'Adicionar' : 'Prosseguir'}}
          </button>
        }
      </div>
      <ul class="subpoptionals">
        @for (subpop of current.subpoptionals; track subpop; let idxSub = $index) {
          <li [class.picked]="curSelection.subpoptionals[idxSub].qty > 0">
            <div class="sub-main">
              <div class="sub-info">
                <span class="sub-name">{{subpop.name}}</span>
                @if ((current.priceNumber + subpop.priceNumber) > 0) {
                  <span class="price">
                    +{{(current.priceNumber + subpop.priceNumber) | currency:'BRL'}}
                  </span>
                }
              </div>
              @if (curSelection.selectionType == 'buttons') {
                <div class="input-group quantity-group">
                  <button class="btn btn-sm btn-danger input-group-prepend"
                    [disabled]="curSelection.subpoptionals[idxSub].qty <= 0"
                    (click)="curSelection.lessQty(idxSub)">
                    <fa-icon [icon]="faMinus"></fa-icon>
                  </button>
                  <input type="number" class="form-control quantity" [value]="curSelection.subpoptionals[idxSub].qty" readonly/>
                  <button class="btn btn-sm btn-success input-group-append"
                    [disabled]="curSelection.maxReached || curSelection.subpoptionals[idxSub].maxReached"
                    (click)="curSelection.moreQty(idxSub)">
                    <fa-icon [icon]="faPlus"></fa-icon>
                  </button>
                </div>
              }
              @if (curSelection.selectionType == 'check') {
                <label class="pill custom-pill">
                  <input type="checkbox" class="ios-switch bigswitch" (change)="toggleCheckbox(idxSub)"
                    [checked]="curSelection.subpoptionals[idxSub].qty > 0"
                    [disabled]="!curSelection.canToggle(idxSub)"/>
                  <div>
                    <div></div>
                  </div>
                </label>
              }
            </div>
            @if (curSelection.subpoptionals[idxSub].totalPrice > 0) {
              <div class="line-price">{{curSelection.subpoptionals[idxSub].totalPrice | currency:'BRL'}}</div>
            }
          </li>
        }
      </ul>
    </div>
  }
  @if (current.subpoptionals.length == 0) {
    <div class="plain-choice">
      @if (curSelection.selectionType == 'buttons') {
        <div class="input-group quantity-group">
          <button class="btn btn-sm btn-danger input-group-prepend"
            [disabled]="curSelection.qty <= 0"
            (click)="curSelection.lessQty()">
            <fa-icon [icon]="faMinus"></fa-icon>
          </button>
          <input type="number" class="form-control quantity" [value]="curSelection.qty" readonly/>
          <button class="btn btn-sm btn-success input-group-append"
            [disabled]="curSelection.maxReached"
            (click)="curSelection.moreQty()">
            <fa-icon [icon]="faPlus"></fa-icon>
          </button>
        </div>
      }
      @if (curSelection.selectionType == 'check') {
        <label class="pill custom-pill">
          <input type="checkbox" class="ios-switch bigswitch" (change)="toggleCheckbox()"
            [checked]="curSelection.qty > 0"/>
          <div>
            <div></div>
          </div>
        </label>
      }
      <span class="price">{{curSelection.totalPrice | currency:'BRL'}}</span>
    </div>
  }

  <hr/>

  <div class="nav-row">
    <button class="btn btn-md btn-secondary back-bot-btn" (click)="goBack()">
      Voltar
    </button>
    <button class="btn btn-md btn-primary proceed-bot-btn" (click)="proceed()" [disabled]="!curSelection.minReached">
      {{lastStep() ? 'Adicionar ao pedido' : 'Prosseguir'}}
    </button>
  </div>
</div>
